<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      line-form
      show-save-button
      unit="员工档案"
      edit-title
      id-key="EmpId"
      :data="data"
      @create-opened="onCreateOpened"
      @opened="onOpened"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="员工姓名" prop="EmpName" label-width="120px">
              <span>{{ data.EmpName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证" prop="IDNumber" label-width="120px">
              <span>{{ data.IDNumber }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="Sex" label-width="120px">
              <span v-if="data.Sex === 0">男</span>
              <span v-if="data.Sex === 1">女</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="婚否" prop="MaritalStatus" label-width="120px">
              <span v-if="data.MaritalStatus === 0">未婚</span>
              <span v-if="data.MaritalStatus === 1">已婚</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="Birthday" label-width="120px">
              <span>{{ $commonJs.toDateString(data.Birthday) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄" label-width="120px">
              <span>{{ data.Age }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="iShow('NativePlace')">
            <el-form-item label="户口所在地" label-width="120px">
              <span>{{ data.NativePlace }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="iShow('Address')">
            <el-form-item label="通讯地址" label-width="120px">
              <span>{{ data.Address }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone" label-width="120px">
              <span>{{ data.Phone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系邮箱" label-width="120px" prop="Email">
              <span>{{ data.Email }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职日期" prop="EntryDate" label-width="120px">
              <span> {{ $commonJs.toDateString(data.EntryDate) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职岗位" prop="JobName" label-width="120px">
              <span>{{ data.JobName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职职级" prop="RankName" label-width="120px">
              <span>{{ data.RankName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="入职状态"
              prop="EntryStatus"
              label-width="120px"
            >
              <span v-if="data.EntryStatus === 0">试用员工</span>
              <span v-if="data.EntryStatus === 1">正式员工</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职部门" prop="DpName" label-width="120px">
              <span>{{ data.DpName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职职位" label-width="120px" prop="TypeName">
              <span>{{ data.TypeName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="iShow('School')">
            <el-form-item label="毕业学校" label-width="120px">
              <span>{{ data.School }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('Education')">
            <el-form-item label="学历" label-width="120px">
              <span>{{ data.Education }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('Major')">
            <el-form-item label="专业" label-width="120px">
              <span>{{ data.Major }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="iShow('Contact')">
            <el-form-item label="紧急联系人" label-width="120px">
              <span>{{ data.Contact }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('EmergencyPhone')">
            <el-form-item label="紧急联系人电话" label-width="120px">
              <span>{{ data.EmergencyPhone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('ContactRelationship')">
            <el-form-item label="紧急联系人关系" label-width="120px">
              <span>{{ data.ContactRelationship }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="iShow('FileUrl')">
          <el-col :span="12">
            <el-form-item label="附件" label-width="120px">
              <!-- <el-input v-model="data.attachment" placeholder="请输入部门编码" /> -->
              <upload-file is-detail :tip="tip"></upload-file>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <dp-dialog ref="dpDialog" in-dialog selectable @select="setDp" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <job-dialog ref="jobDialog" in-dialog selectable @select="setJob" />
    <rank-dialog ref="rankDialog" in-dialog selectable @select="setRank" />
  </div>
</template>
<script>
import detailDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
import uploadFile from "@/components/common/files/uploadFile";
// import empDialog from "@/components/personnel/result/record/listDialog";
import empDialog from "@/components/basedata/personnel/employee/listDialog";
import dpDialog from "@/components/basedata/personnel/dp/listDialog";
import jobDialog from "@/components/basedata/personnel/job/listDialog";
import rankDialog from "@/components/basedata/personnel/rank/listDialog";

export default {
  mixins: [detailDialogMixin],
  components: {
    commonDialog,
    uploadFile,
    empDialog,
    dpDialog,
    jobDialog,
    rankDialog,
  },
  data() {
    return {
      data: {
        EmpId: 0,
        EmpName: "",
        IDNumber: "",
        Age: "",
        Sex: 1,
        // 部门
        DpId: null,
        DpName: "",
        // 岗位
        JobId: null,
        JobName: "",
        // 职位
        EmpTypeId: null,
        TypeName: "",
        // 职级
        RankId: "",
        RankName: "",
        MaritalStatus: 1,
        Birthday: "",
        NativePlace: "",
        Address: "",
        Phone: null,
        Email: "",
        EntryDate: "",
        EntryStatus: 1,
        School: "",
        Education: "",
        Major: "",
        Contact: "",
        EmergencyPhone: "",
        ContactRelationship: "",
        FileUrl: "",
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ent/emp").default,
      jobApi: require("@/api/ent/job").default,
      empTypeApi: require("@/api/ent/emptype").default,
      rankApi: require("@/api/ent/rank").default,
      jobList: [],
      empTypeList: [],
      rankList: [],
      showList: [],
      rules: {},
      tip: "请先修改好文件名再上传，大小不超过10Mb",
    };
  },

  methods: {
    onCreateOpened() {},
    onOpened() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    // onOpened() {
    //   // this.$refs.typeSelect.init();
    // },
    onBeforeSave() {},

    //判断显示
    iShow(data) {
      //console.log(this.showList);
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    getAge(data) {
      console.log(data);
      if (data == "") return (this.data.Age = "");
      // 将出生日期的字符串通过"-"分割成数组
      const strBirthdayArr = data?.split("-");
      // 拿到出生日期的年
      const birthYear = strBirthdayArr[0];
      // 拿到出生日期的月
      const birthMonth = strBirthdayArr[1];
      // 拿到出生日期的日
      const birthDay = strBirthdayArr[2];
      // 创建一个时间对象
      const d = new Date();
      // 拿到当前时间的年
      const nowYear = d.getFullYear();
      // 拿到当前时间的月
      const nowMonth = d.getMonth() + 1;
      // 拿到当前时间的日
      const nowDay = d.getDate();
      // 如果出生日期的年等于当前时间的年
      if (nowYear === birthYear) return 0; // 返回周岁年龄 0,并终止函数执行
      // 如果如果出生日期的年不等于于当前时间的年,则拿到年之差
      const ageDiff = nowYear - birthYear; // 年之差
      // 如果年之差是个负数,则表示用户输入的出生日期错误,晚于今天,返回 -1,并终止函数执行
      if (ageDiff < 0) return -1; // 返回错误 -1,并终止函数执行
      // 如果年之差是个正整数,但出生日期的月与当前时间的月不相等
      if (nowMonth !== birthMonth) {
        // 拿到出生日期的日与当前时间的月之差
        const monthDiff = nowMonth - birthMonth; // 月之差
        // 如果月之差是个负数,则年之差 - 1后得到周岁年龄,否则直接得到周岁年龄
        return (this.data.Age = monthDiff < 0 ? ageDiff - 1 : ageDiff); // 返回周岁年龄,并终止函数执行
      }
      // 如果出生日期的月与当前时间的月相等,则拿到出生日期的日与当前时间的日之差
      const dayDiff = nowDay - birthDay;
      // 如果日之差是个负数,则年之差 - 1得到周岁年龄,否则直接得到周岁年龄

      return (this.data.Age = dayDiff < 0 ? ageDiff - 1 : ageDiff); // 返回周岁年龄,并终止函数执行
    },
    openJobDialog() {
      this.$refs.jobDialog.open();
    },
    openRankDialog() {
      this.$refs.rankDialog.open();
    },
    openDpDialog() {
      this.$refs.dpDialog.open();
    },
    openEmpDialog() {
      this.$refs.empDialog.open();
    },
    setEmp(emp) {
      console.log(emp);
      this.data.EmpTypeId = emp.EmpTypeId;
      this.data.TypeName = emp.TypeName;
    },
    setRank(rank) {
      console.log(rank);
      this.data.RankId = rank.RankId;
      this.data.RankName = rank.RankName;
    },
    setJob(job) {
      console.log(job);
      this.data.JobId = job.JobId;
      this.data.JobName = job.JobName;
    },
    setDp(dp) {
      console.log(dp);
      this.data.DpId = dp.DpId;
      this.data.DpName = dp.DpName;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>